 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"winterGame": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"winterGame": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"chunk-2adf2bb9":"92da89f2","chunk-2d0c5184":"6b44adc3","chunk-42981432":"e9ab100b","chunk-47c9b0de":"b31acea6","chunk-5e9d40a2":"c8a8022e","chunk-6a21e3ca":"3140c53e","chunk-738e1d18":"e1f0a389","chunk-02b1d43a":"4148f489","chunk-24248c89":"e6c87ee3","chunk-370a1280":"77b321ab","chunk-7606cc59":"9cdab9e2","chunk-bc73e60c":"755d68b1","chunk-fc2c3a82":"80aa3b09","chunk-053ac566":"d0249a41","chunk-21f6a602":"4554b6c1","chunk-2acc2193":"b66cf28a","chunk-2d216257":"5e731856","chunk-321208ce":"df937a82","chunk-1392442d":"5df974cd","chunk-00f69456":"f95511df","chunk-432d6a5d":"93043e86","chunk-024e788e":"8e5c8513","chunk-09564494":"31e8eb53","chunk-0b27ba4c":"8ee66865","chunk-1445d46b":"6fac7285","chunk-232b8d84":"72d9d1bf","chunk-30b2bd2c":"181fb600","chunk-4cbeb239":"a94eafd9","chunk-7c512478":"12273fea","chunk-b8d1d1d2":"b805f7f1","chunk-ef3ae8b0":"1245274e","chunk-11b8b758":"50609d1a","chunk-744d31c4":"edc5d13f","chunk-8ee4c71e":"36f9052c","chunk-c7e4c9d4":"77484500","chunk-1b38faed":"b413d28b","chunk-3cada1c6":"178660b6","chunk-8e359fac":"3bce9234","chunk-e0175948":"7d1063f2","chunk-36054996":"b3b02ce8","chunk-4320be18":"6821b141","chunk-d3033bfe":"c53957f8","chunk-603d9012":"952ab7f3","chunk-617d8b69":"503cecc6","chunk-7b56809e":"aad55f0b","chunk-6a3d7d34":"c4dd16f5","chunk-c4d0e9a6":"c024ab5c","chunk-dacee354":"aafa7622","chunk-88eebb62":"8e65d848","chunk-99fce820":"d9ea6534"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-2adf2bb9":1,"chunk-42981432":1,"chunk-47c9b0de":1,"chunk-5e9d40a2":1,"chunk-6a21e3ca":1,"chunk-02b1d43a":1,"chunk-24248c89":1,"chunk-370a1280":1,"chunk-7606cc59":1,"chunk-bc73e60c":1,"chunk-fc2c3a82":1,"chunk-053ac566":1,"chunk-21f6a602":1,"chunk-2acc2193":1,"chunk-1392442d":1,"chunk-00f69456":1,"chunk-432d6a5d":1,"chunk-024e788e":1,"chunk-09564494":1,"chunk-0b27ba4c":1,"chunk-1445d46b":1,"chunk-232b8d84":1,"chunk-30b2bd2c":1,"chunk-4cbeb239":1,"chunk-7c512478":1,"chunk-b8d1d1d2":1,"chunk-ef3ae8b0":1,"chunk-11b8b758":1,"chunk-744d31c4":1,"chunk-8ee4c71e":1,"chunk-c7e4c9d4":1,"chunk-1b38faed":1,"chunk-3cada1c6":1,"chunk-8e359fac":1,"chunk-e0175948":1,"chunk-36054996":1,"chunk-4320be18":1,"chunk-d3033bfe":1,"chunk-603d9012":1,"chunk-617d8b69":1,"chunk-7b56809e":1,"chunk-6a3d7d34":1,"chunk-c4d0e9a6":1,"chunk-88eebb62":1,"chunk-99fce820":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({}[chunkId]||chunkId) + "." + {"chunk-2adf2bb9":"f49abb0d","chunk-2d0c5184":"31d6cfe0","chunk-42981432":"d2cea4aa","chunk-47c9b0de":"014538a9","chunk-5e9d40a2":"8101b0ba","chunk-6a21e3ca":"7201b324","chunk-738e1d18":"31d6cfe0","chunk-02b1d43a":"5c6a8a31","chunk-24248c89":"aa26f275","chunk-370a1280":"da675dcb","chunk-7606cc59":"ac6987f0","chunk-bc73e60c":"c5a78e12","chunk-fc2c3a82":"f2b8e47a","chunk-053ac566":"5563cddd","chunk-21f6a602":"d471823c","chunk-2acc2193":"25b78ff8","chunk-2d216257":"31d6cfe0","chunk-321208ce":"31d6cfe0","chunk-1392442d":"f84cc9ca","chunk-00f69456":"9ab26e91","chunk-432d6a5d":"54a1dd27","chunk-024e788e":"f1c42f69","chunk-09564494":"8ab13f8e","chunk-0b27ba4c":"78189f1d","chunk-1445d46b":"7921d4b3","chunk-232b8d84":"159266f1","chunk-30b2bd2c":"7d809dd5","chunk-4cbeb239":"aadd187e","chunk-7c512478":"5b9f5fa5","chunk-b8d1d1d2":"2a2d2ea5","chunk-ef3ae8b0":"583244cf","chunk-11b8b758":"20a4c54a","chunk-744d31c4":"7820f8d0","chunk-8ee4c71e":"1439914e","chunk-c7e4c9d4":"a22726f9","chunk-1b38faed":"317082c0","chunk-3cada1c6":"870470af","chunk-8e359fac":"4543164a","chunk-e0175948":"66d39495","chunk-36054996":"e95fe8e1","chunk-4320be18":"f4addd91","chunk-d3033bfe":"22ad9c28","chunk-603d9012":"c475d2d7","chunk-617d8b69":"681ed568","chunk-7b56809e":"686d9e90","chunk-6a3d7d34":"2dba3d18","chunk-c4d0e9a6":"7ca9c3ac","chunk-dacee354":"31d6cfe0","chunk-88eebb62":"354994d0","chunk-99fce820":"72ddeb5a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//statics.classba.cn/prod/pad_dl_evaluation/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([21,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
